import type { RouteLocationRaw } from "vue-router";

// Ссылка на Журнал заказов «сразу на этих строках» (CAB-782): по адресу
// `/app/eplex/journal?rows=<hash_key,…>` журнал подгружает названные строки,
// выделяет их и прокручивает к первой. Так тост об ошибке оформления из Быстрой
// корзины ведёт не в журнал вообще, а к позиции, которую нужно повторить.

export const JOURNAL_PATH = "/app/eplex/journal";
export const JOURNAL_ROWS_QUERY_KEY = "rows";

/** Маршрут в журнал с выделением строк; без ключей — обычный переход в журнал. */
export function journalRowsLocation(hashKeys: readonly string[]): RouteLocationRaw {
  const keys = hashKeys.filter((key) => key.length > 0);
  if (keys.length === 0) return { path: JOURNAL_PATH };
  return { path: JOURNAL_PATH, query: { [JOURNAL_ROWS_QUERY_KEY]: keys.join(",") } };
}

/**
 * Ключи строк из значения query-параметра. Параметр может прийти массивом
 * (повторён в адресе) — берём первое значение; пустоту и пробелы отбрасываем.
 */
export function parseJournalRowKeys(raw: unknown): string[] {
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (typeof value !== "string") return [];

  return Array.from(
    new Set(
      value
        .split(",")
        .map((key) => key.trim())
        .filter((key) => key.length > 0),
    ),
  );
}
